export default {
  namespaced: true,

  getters: {
    enabled(state, getters, rootState, rootGetters) {
      if (!rootGetters['builder/field/enabled']) {
        return false;
      }

      return true;
    },

    required(state, getters) {
      return getters.enabled;
    },
  },
};
